import { render, staticRenderFns } from "./new-historiqueCotation.vue?vue&type=template&id=1fef264e"
import script from "./new-historiqueCotation.vue?vue&type=script&lang=js"
export * from "./new-historiqueCotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports